import React, { useMemo } from 'react';
import { EmptyEmailPreview } from './EmptyEmailPreview';
import { EmailPreview } from './EmailPreview';
import { SenderDetailsSelector } from '../sender-details-selector';
import type { SenderDetailsUpdate } from '../types';

interface EmailSetupProps {
  subject: string;
  previewText: string;
  html: string;
  css: string;
  onSubjectChange: (value: string) => void;
  onPreviewTextChange: (value: string) => void;
  senderProfileId: string | null | undefined;
  usePointOfContactSender?: boolean;
  onSenderProfileChange: (update: SenderDetailsUpdate) => void;
}

export const EmailSetup: React.FC<EmailSetupProps> = ({
  subject,
  previewText,
  html,
  css,
  onSubjectChange,
  onPreviewTextChange,
  senderProfileId,
  usePointOfContactSender,
  onSenderProfileChange,
}) => {
  const previewHtml = useMemo(() => {
    if (!html) return '';
    const styles = `<style>html, body { margin: 0; padding: 0; }${css || ''}</style>`;
    return html.replace('</head>', `${styles}</head>`);
  }, [html, css]);

  const hasContent = html && html.trim().length > 0;

  return (
    <fieldset>
      <legend>Email</legend>
      <label>
        Subject Line
        <input
          type="text"
          value={subject}
          onChange={e => onSubjectChange(e.target.value)}
          placeholder="Enter email subject..."
        />
      </label>
      <SenderDetailsSelector
        senderProfileId={senderProfileId}
        usePointOfContactSender={usePointOfContactSender}
        onChange={onSenderProfileChange}
      />
      <label>
        Preview Text
        <input
          type="text"
          value={previewText}
          onChange={e => onPreviewTextChange(e.target.value)}
          placeholder="This appears in the inbox preview..."
        />
      </label>
      <label>
        Email Template
        <span>Design your email template using our visual editor</span>
      </label>
      {hasContent ? <EmailPreview html={previewHtml} /> : <EmptyEmailPreview />}
    </fieldset>
  );
};
